<template>
	<div class="no-content">
		<h1 class="text-primary mb-25">
			{{ $tc('components.noContentTitle') }}
		</h1>
		<p>{{ $tc('common.contactSupportText') }}</p>
	</div>
</template>

<script>
export default {
	name: 'NoContent'
}
</script>

<style lang="scss">
	.no-content {
		height: 700px;
		text-align: center;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
</style>
